import { useParams, useLocation } from 'react-router-dom';
import { useOrgHost } from '@/contexts/OrgHostContext';
import { useOrgMemberStore } from '@/store/orgMember';
import { resolvePublicOrgSlug } from '@/lib/resolvePublicOrgSlug';

/**
 * Resolved org slug for unified public site API calls and path-mode links.
 * On subdomains, uses the loaded organization's slug (not the hostname label).
 *
 * Path-mode layout routes (e.g. OrgHostOutlet) may not receive child :orgSlug via
 * useParams in react-router v7, so we also parse the current pathname.
 */
export function useOrgSlug(): string | undefined {
  const { orgSlug: orgSlugParam } = useParams<{ orgSlug?: string }>();
  const location = useLocation();
  const { pathSlug, host, organization } = useOrgHost();
  const storeSlug = useOrgMemberStore((s) => s.orgSlug);

  return resolvePublicOrgSlug({
    orgSlugParam,
    pathname: location.pathname,
    orgHostPathSlug: pathSlug,
    orgHostOrganizationSlug: organization?.slug,
    storeOrgSlug: storeSlug,
    isSubdomainHost: host.mode === 'subdomain',
  });
}
